import { useState } from "react";
import "../../../App.css";
import Listdelete from "./ListDelete";

import Add from "./Add";

function Departments() {
  const [counter, setCounter] = useState(0);

  const increment = () => {
    setCounter(counter + 1);
  };

  return (
    <div className="App">
      <Add increment={increment} counter={counter} />

      <Listdelete
        increment={increment}
        counter={counter}
        setCounter={setCounter}
      />
    </div>
  );
}

export default Departments;
